export const disableDragProps = {
  draggable: false,
  onDragStart: (e: React.DragEvent) => {
    e.preventDefault();
    return false;
  },
};
